import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { useGlobalState } from 'hooks/useGlobalState';
import { hostedRegionTimings } from 'utils/constants';
import styles from './ProgressBar.module.scss';

export default function ProgressBar() {
  const innerBar = useRef();

  const [
    {
      signup,
      waitingScreen: { journeyCompleted },
    },
  ] = useGlobalState();

  const customerRegion = signup.data?.region ?? 'APAC';

  // Get the max timing for customer's region from the `hostedRegionTimings`,
  // use that to determine the max length of the loading animation.
  const maxAnimationTime = Number(hostedRegionTimings[customerRegion].slice(2));

  const slowAnimation = useRef(gsap.timeline({ paused: false }));

  useEffect(() => {
    const currentAnimation = slowAnimation.current;
    currentAnimation.to(innerBar.current, {
      ease: 'power2.out',
      width: '95%',
      duration: maxAnimationTime,
    });

    return () => currentAnimation.kill();
  }, [maxAnimationTime]);

  useEffect(() => {
    if (journeyCompleted) {
      slowAnimation.current.clear().to(innerBar.current, {
        width: '100%',
        ease: 'power3.inOut',
        duration: 1,
      });
    }
  }, [journeyCompleted]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.outerBar}>
        <div className={styles.innerBar} ref={innerBar}></div>
      </div>
    </div>
  );
}
